import { render, staticRenderFns } from "./IconArrowSquare.vue?vue&type=template&id=529ad473"
import script from "./IconArrowSquare.vue?vue&type=script&lang=js"
export * from "./IconArrowSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports